import React from 'react'

import Button from 'components/Button'

import Refrigerator from 'assets/img/product-details/tudo/refrigerator.png'
import BgRefrigerator from 'assets/img/product-details/tudo/bg_refrigerator.png'

import { Desc, Title, Header } from './style'
import {
    Container,
    Content,
    Info,
    Subtitle,
    Background,
    LinkButton
} from './ProductTudoHowIsPat.style'

const ProductTudoHowIsPat = () => {
    return (
        <Container>
            <Header>
                <Title>Como fica o PAT?</Title>
                <Desc>
                    Nada muda em relação ao Programa de Alimentação do
                    Trabalhador
                </Desc>
            </Header>
            <Content>
                <div className="img-wrap">
                    <img
                        className="hero"
                        src={Refrigerator}
                        alt="Beneficios do Alelo Tudo"
                    />
                </div>
                <Info>
                    <Subtitle>
                        Para você, que quer dar benefícios como Alimentação e
                        Refeição, temos a solução, pois as contas do Alelo Tudo
                        são segregadas e garantem a finalidade específica de
                        cada benefício.
                    </Subtitle>
                    <Desc>
                        Ou seja, os valores disponibilizados para cada uma das
                        contas não se misturam, trazendo mais segurança jurídica
                        para a sua empresa.
                    </Desc>
                </Info>
                <Background
                    src={BgRefrigerator}
                    alt="Beneficios do Alelo Tudo"
                />
            </Content>
            <LinkButton href="#">
                <Button kind="add">Me interessei!</Button>
            </LinkButton>
        </Container>
    )
}

export default ProductTudoHowIsPat
